import React, { useEffect, useState } from "react";
import "./PackDescriptionComponent.css";
import hdIcon from "../../../images/img/hd-icon.svg";
import sdIcon from "../../../images/img/sd-icon.svg";
import { isNull } from "lodash";
export default function PackDescriptionComponent(props) {
  console.log("props in packDescription", props);
  useEffect(() => {
    console.log(localStorage.getItem("packDescription"), "local storage");
  }, []);

  const toggledStyle = {
    height: "14rem",
    overflowY: "scroll",
  };
  const [toggle, setToggle] = useState(0);
  const [showMoreToggle, setShowMoreToggle] = useState(null);
  const { data } = props;
  return (
    <div className="packDescriptionContainer chatIn-header help-assistantwrapp">
      <div
        className="packDescriptionClose"
        onClick={props.closeDescriptionComponent}
      >
        <i class="demo-icon icon-close-1"></i>
      </div>
      <div className="header-packsDescription">
        <div className="header-packsDescription-title">
          <p>{data.name}</p>
        </div>
        <div className="header-packsDescription-overView">
          <div className="header-packsDescription-left">
            <div className="totalChannels">Total Channels</div>
            <div className="hdSdContaoiner-left">
              <div className="hdSdBox">
                <img src={hdIcon}></img>
                <p>{data.noOfHdChannels}</p>
              </div>
              <div className="hdSdBox">
                <img src={sdIcon}></img>
                <p>{data.noOfSdChannels}</p>
              </div>
            </div>
          </div>
          <div className="header-packsDescription-middle"></div>
          <div className="header-packsDescription-right">
            <div className="neMonthlyCharges-top">
              <p>New Monthly Charges</p>
            </div>
            <div className="neMonthlyCharges-bottom">
              <p>{data.description}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="middle-packsDescription">
        {data.moreDetails.viewChannelList.length !== 0 &&
          data.moreDetails.viewChannelList.map((onePack, index) => (
            <div className="oneCategoryContainer" key={index}>
              <div className="oneCategory-header" style={{backgroundColor:index===toggle ?'#f5f5f5' : 'white',
            borderBottom:index===toggle && 'none' }}>
                <div className="category-header-name"><p>{onePack.name}</p></div>
                <div className="countandArrow">
                  <div>
                    <p>{`${onePack.noOfChannels} Channels`}</p>
                  </div>
                  {toggle === index ? (  
                  <div
                    className="arrow-up"
                    onClick={() =>toggle ===  index ?   setToggle(null): setToggle(index)}
                  ></div>):(<div
                  className="arrow-down"
                  onClick={() =>toggle ===  index ?   setToggle(null): setToggle(index)}
                ></div>)}
                </div>
              </div>
              {toggle === index ? (
                <div
                  className={showMoreToggle===index ?"channlesContainer-desc-more" :"channlesContainer-desc"} 
                  
                >
                  {onePack.channelList.map((oneChannel) => (
                    <div className="oneChannelBox-desc">
                      <div className="oneChannel-image">
                        <img src={oneChannel.imageLink}></img>
                      </div>
                      <div className="oneChannel-name">{oneChannel.name}</div>
                      <div className="oneChannel-no">{"Ch.435"}</div>
                    </div>
                  ))}
                </div>
              ) : null}
              {onePack.noOfChannels > 4 ? (
                <div
                  className="showMoreLessToggle"
                  style={{ marginTop: toggle === index ? "5%" : "0%" }}
                >
                  {toggle === index ? (
                    showMoreToggle === index ? (
                      <p onClick={()=>setShowMoreToggle(null)}>View Less</p>
                    ) : (
                      <p onClick={()=>setShowMoreToggle(index)}> View All</p>
                    )
                  ) : null}
                </div>
              ) : null}
            </div>
          ))}
      </div>
      <div className="footer-packsDescription">
        <button
          className="btn btn-secondary mT10 waves-effect waves-light close-model "
          onClick={props.closeDescriptionComponent}
        >
          <p>Go Back to Chat</p>
        </button>
        <button
          className="btn btn-secondary mT10 waves-effect waves-light close-model "
          onClick={props.selectDesctipon}
        >
          <p>Get This Pack</p>
        </button>
      </div>
    </div>
  );
}
